import { RenewalEligibility } from 'merchant-api/types';
import { queryOptions, useQuery, UseQueryResult } from '@tanstack/react-query';
import useParties from '../useParties/useParties';
import { spiceroad } from '..';

export interface RenewalProps {
  isRenewalLoading: boolean;
  renewal: RenewalEligibility | undefined;
  isRenewalError: any;
  query: UseQueryResult<RenewalEligibility>;
}

const getRenewalData = () =>
  spiceroad.get<RenewalEligibility>('/v1/renewal', {validateStatus: (status) => [200, 404].includes(status)})
    .then((res) => res.data);

export const getRenewalOpts = queryOptions<RenewalEligibility>({
  queryKey: ['renewal'],
  queryFn: getRenewalData,
});

export function getRenewal(): RenewalProps {
  const { isRenewal } = useParties();
  const query = useQuery({
    ...getRenewalOpts,
    enabled: isRenewal,
  });
  const { data, error, isLoading } = query;
  return {
    renewal: data,
    isRenewalLoading: isLoading,
    isRenewalError: error,
    query,
  };
}

export default getRenewal;
